import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';

import styles from './confidence-toggle.module.css';

type ConfidenceToggleProps = {
    useConfidence: boolean;
    isDisabled: boolean;
    isSmall?: boolean;
    onToggle: (...args: any) => any;
};

export class ConfidenceToggle extends React.PureComponent<ConfidenceToggleProps> {
    render() {
        const label = this.props.isSmall ? 'Use confidence' : 'Forecast pipeline by confidence';

        return (
            <div
                className={this.props.isDisabled ? styles['container--disabled'] : styles.container}
            >
                <Checkbox
                    label={label}
                    isLarge={true}
                    disabled={this.props.isDisabled}
                    checked={this.props.useConfidence}
                    onChange={this.props.onToggle}
                />
            </div>
        );
    }
}
